import { render, staticRenderFns } from "./SmbButton.vue?vue&type=template&id=375cc9fa&scoped=true&"
import script from "./SmbButton.vue?vue&type=script&lang=ts&"
export * from "./SmbButton.vue?vue&type=script&lang=ts&"
import style0 from "./SmbButton.scss?vue&type=style&index=0&id=375cc9fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cc9fa",
  null
  
)

export default component.exports